export class ThreadMessageReaction {
    constructor(model) {
        this.messageId = model.messageId;
        this.userId = model.userId;
        this.emoji = model.emoji;
        this.createdAt = new Date(model.createdAt);
    }
    toRemote() {
        return Object.assign(Object.assign({}, this), { createdAt: this.createdAt.toISOString() });
    }
}
